export default {
  title: 'Acercamos el mundo al aula y el aula al mundo',
  categoriesTitle: 'Fomentamos experiencias de aprendizaje en contextos reales',
  categoriesDescription: 'Planes de clases y recursos docentes para educar en pos del desarrollo sostenible y  la ciudadanía mundial.',
  computationalThinking: {
    title: 'Pensamiento computacional',
    subtitle: 'La lógica de siglo XXI',
    description: 'Resolución de problemas del entorno mediante la aplicación de conceptos informáticos, en pos de construir una lógica de pensamiento transferible a otros ámbitos.'
  },
  globalCitizenship: {
    title: 'Ciudadanía global',
    subtitle: 'La realidad que nos rodea',
    description: 'Análisis de situaciones y problemáticas actuales, locales y mundiales, como la convivencia, el respeto o la sostenibilidad, para comprender y actuar en el mundo de hoy.'
  },
  entrepreneurialSpirit: {
    title: 'Espíritu emprendedor',
    subtitle: 'La actitud frente a la vida',
    description: 'Desarrollo de habilidades emprendedoras y sociales para fomentar la capacidad de identificación de oportunidades y de llevar a cabo cambios que impacten en la comunidad.'
  },
  odsTitle: 'Promovemos los ODS',
  odsSubtitle: 'Los objetivos de desarrollo sostenible son un componente nodal en nuestro contenido. A través de recursos creativos, todos los planes de clase de Kimple invitan a los estudiantes a involucrarse en la Agenda 2030.',
  skillsTitle: 'Potenciamos el desarrollo competencial',
  skillsDescription: 'Todos los recursos de Kimple proponen dinámicas que fomentan el desarrollo de las siguientes habilidades y competencias:',
  skills: {
    problemResolution: 'Resolución de problemas',
    flexibility: 'Flexibilidad',
    criticalThinking: 'Pensamiento Crítico',
    initiative: 'Iniciativa',
    perseverance: 'Perseverancia',
    creativity: 'Creatividad',
    leadership: 'Liderazgo',
    effectiveCommunication: 'Comunicación efectiva',
    curiosity: 'Curiosidad',
    commitment: 'Compromiso',
    resilience: 'Resilencia',
    teamwork: 'Trabajo en equipo'
  },
  authorsTitle: 'Nuestros programas y nuestros autores',
  authorsDescription: '<span class="text-xbig">Especialistas, fundaciones, creativos, docentes y autores destacados en las diferentes áreas construyen una propuesta de contenidos única, <span class="text-xbig bold">desafiante y de alto impacto</span></span>',
  smallCard1: {
    title: 'Kimple',
    description: 'Pensamiento computacional y programación'
  },
  smallCard2: {
    title: 'YPD',
    description: 'Emprendedurismo'
  },
  smallCard3: {
    title: 'World’s Largest Lesson',
    description: 'Promoción de los ODS'
  },
  smallCard4: {
    title: 'Ecohouse',
    description: 'Educación ambiental'
  },
  smallCard5: {
    title: 'Newtral Education',
    description: 'Fake news'
  },
  smallCard6: {
    title: 'Mentes inquietas',
    description: 'Filosofía y pensamiento crítico'
  },
  smallCard7: {
    title: 'Possible Lab',
    description: 'ODS y programación'
  },
  smallCard8: {
    title: 'Garaje',
    description: 'Arte como herramienta de prevención'
  },
  smallCard9: {
    title: 'Fad',
    description: 'Pensamiento crítico.'
  },
  smallCard10: {
    title: 'M.de Laferrère, F. Fernández Cisneros',
    description: 'Educación socioemocional'
  },
  smallCard11: {
    title: 'Holocaust Memorial Day Trust',
    description: 'Genocidio y discursos de odio'
  },
  smallCard12: {
    title: 'Stand Up Education Against Discrimination',
    description: 'No discriminación y no violencia'
  },
  smallCard13: {
    title: 'Lic. Silvia Hurrell',
    description: 'Educación afectivo-sexual'
  },
  smallCard14: {
    title: 'Inspiring FC',
    description: 'Oratoria'
  },
  smallCard15: {
    title: 'Earth Echo',
    description: 'Cuidado del agua'
  },
  fullAccess: 'Accede al catálogo completo'
}

export const en = {
  title: 'We bring the world into the classroom and the classroom to the world',
  categoriesTitle: 'We encourage real-world learning experiences',
  categoriesDescription: 'Lesson plans and teaching resources to educate on sustainable development and global citizenship.',
  computationalThinking: {
    title: 'Computational thinking',
    subtitle: '21st century logic',
    description: 'Environmental problem-solving using IT concepts, in order to build a rationale for thinking that can be transferred to other areas.'
  },
  globalCitizenship: {
    title: 'Global Citizenship',
    subtitle: 'Our everyday reality',
    description: "Analysis of both local and global current affairs, such as coexistence, respect and sustainability, to better understand and behave appropriately in today's world."
  },
  entrepreneurialSpirit: {
    title: 'Entrepreneurial spirit',
    subtitle: 'Attitude to life',
    description: 'Development of entrepreneurial and social skills to encourage the ability to identify opportunities and make changes that impact the community.'
  },
  odsTitle: 'We promote SDGs',
  odsSubtitle: 'Sustainable Development Goals are key on our content. Through creative resources, all Kimple lesson plans encourage students to get involved in the 2030 Agenda.',
  skillsTitle: 'We promote skill development',
  skillsDescription: 'All Kimple resources encourage the development of the following skills and competencies:',
  skills: {
    problemResolution: 'Problem solving',
    flexibility: 'Flexibility',
    criticalThinking: 'Critical Thinking',
    initiative: 'Initiative',
    perseverance: 'Perseverance',
    creativity: 'Creativity',
    leadership: 'Leadership',
    effectiveCommunication: 'Effective communication',
    curiosity: 'Curiosity',
    commitment: 'Commitment',
    resilience: 'Resilience',
    teamwork: 'Teamwork'
  },
  authorsTitle: 'Our programmes and our authors',
  authorsDescription: '<span class="text-xbig">Specialists, foundations, creatives, teachers and outstanding authors from different areas build a <span class="text-xbig bold">unique, challenging and high-impact</span> educational programme:</span>',
  smallCard1: {
    title: 'Kimple',
    description: 'Introduction to Computational Thinking'
  },
  smallCard2: {
    title: 'YPD',
    description: 'Entrepreneurship'
  },
  smallCard3: {
    title: 'World’s Largest Lesson',
    description: 'Promotion of the SDGs'
  },
  smallCard4: {
    title: 'Ecohouse',
    description: 'Environmental education'
  },
  smallCard5: {
    title: 'Newtral Education',
    description: 'Fake news'
  },
  smallCard6: {
    title: 'Mentes inquietas',
    description: 'Philosophy and critical thinking'
  },
  smallCard7: {
    title: 'Possible Lab',
    description: 'SDGs and programming'
  },
  smallCard8: {
    title: 'Garaje',
    description: 'Art as a prevention tool'
  },
  smallCard9: {
    title: 'Fad',
    description: 'Critical thinking'
  },
  smallCard10: {
    title: 'M.de Laferrère, F. Fernández Cisneros',
    description: 'Socio-emotional education'
  },
  smallCard11: {
    title: 'Holocaust Memorial Day Trust',
    description: 'Genocide and hate speech'
  },
  smallCard12: {
    title: 'Stand Up Education Against Discrimination',
    description: 'Non-discrimination and non-violence'
  },
  smallCard13: {
    title: 'Lic. Silvia Hurrell',
    description: 'Affective-sexual education'
  },
  smallCard14: {
    title: 'Inspiring FC',
    description: 'Oratory'
  },
  smallCard15: {
    title: 'Earth Echo',
    description: 'Water care'
  },
  fullAccess: 'Access the complete curriculum catalogue'
}

export const ca = {
  title: 'Apropem el món a l’aula i l’aula al món',
  categoriesTitle: 'Fomentem experiències d’aprenentatge en contextos reals',
  categoriesDescription: 'Plans de classes i recursos docents per educar a favor del desenvolupament sostenible i la ciutadania mundial.',
  computationalThinking: {
    title: 'Pensament computacional',
    subtitle: 'La lògica del segle XXI',
    description: 'Resolució de problemes de l’entorn amb l’aplicació de conceptes informàtics a l’encalç de construir una lògica de pensament transferible a altres àmbits.'
  },
  globalCitizenship: {
    title: 'Ciutadania global',
    subtitle: 'La realitat que ens envolta',
    description: 'Anàlisi de situacions i problemàtiques actuals, locals i mundials, com la convivència, el respecte o la sostenibilitat per comprendre i actuar al món d’avui.'
  },
  entrepreneurialSpirit: {
    title: 'Esperit emprenedor',
    subtitle: 'L’actitud davant la vida',
    description: 'Desenvolupament d’habilitats emprenedores i socials per fomentar la capacitat d’identificació d’oportunitats i de dur a terme canvis que tenen impacte en la comunitat.'
  },
  odsTitle: 'Promovem els ODS',
  odsSubtitle: 'Els objectius de desenvolupament sostenible són un component central en el nostre contingut. A través de recursos creatius, tots els plans de classes de Kimple conviden els estudiants a involucrar-se en l\'Agenda 2030.',
  skillsTitle: 'Potenciem el desenvolupament competencial',
  skillsDescription: 'Tots els recursos de Kimple proposen dinàmiques que fomenten el desenvolupament de les habilitats i competències següents:',
  skills: {
    problemResolution: 'Resolució de problemes',
    flexibility: 'Flexibilitat',
    criticalThinking: 'Pensament crític',
    initiative: 'Iniciativa',
    perseverance: 'Perseverança',
    creativity: 'Creativitat',
    leadership: 'Lideratge',
    effectiveCommunication: 'Comunicació efectiva',
    curiosity: 'Curiositat',
    commitment: 'Compromís',
    resilience: 'Resiliència',
    teamwork: 'Treball en equip'
  },
  authorsTitle: 'Els nostres programes i els nostres autors',
  authorsDescription: '<span class="text-xbig">Els especialistes, les fundacions, els creatius, els docents i els autors destacats en les diverses àrees construeixen una proposta de continguts <span class="text-xbig bold">única, desafiadora i de gran impacte</span>:</span>',
  smallCard1: {
    title: 'Kimple',
    description: 'Pensament computacional i programació'
  },
  smallCard2: {
    title: 'YPD',
    description: 'Emprenedoria'
  },
  smallCard3: {
    title: 'World’s Largest Lesson',
    description: 'Promoció dels ODS'
  },
  smallCard4: {
    title: 'Ecohouse',
    description: 'Educació ambiental'
  },
  smallCard5: {
    title: 'Newtral Education',
    description: 'Fake news'
  },
  smallCard6: {
    title: 'Mentes inquietas',
    description: 'Filosofia i pensament crític'
  },
  smallCard7: {
    title: 'Possible Lab',
    description: 'ODS i programació'
  },
  smallCard8: {
    title: 'Garaje',
    description: 'Art com a eina de prevenció'
  },
  smallCard9: {
    title: 'Fad',
    description: 'Pensament crític'
  },
  smallCard10: {
    title: 'M.de Laferrère, F. Fernández Cisneros',
    description: 'Educació socioemocional'
  },
  smallCard11: {
    title: 'Holocaust Memorial Day Trust',
    description: "Genocidi i discursosd'odi"
  },
  smallCard12: {
    title: 'Stand Up Education Against Discrimination',
    description: 'No discriminació i no violència'
  },
  smallCard13: {
    title: 'Lic. Silvia Hurrell',
    description: 'Educació afectiva i sexual'
  },
  smallCard14: {
    title: 'Inspiring FC',
    description: 'Oratòria'
  },
  smallCard15: {
    title: 'Earth Echo',
    description: 'Cura de l\'aigua'
  },
  fullAccess: 'Accedeix al catàleg complet de programes educatius'
}
